import config, { Environment } from '../../../config/config'

/**
 * Checks for the test production account or any staging account.
 * A development environment will also pass the check.
 */
export const hasUrlFeatureFlag = (): boolean => {
  const isEnabled = config.environment !== Environment.PRODUCTION || config.getAccountSlug() === 'test'
  return isEnabled
}

/**
 * Checks for the train production account or the studio2 staging account.
 * A development environment will also pass the check.
 */
export const hasUrlFeatureFlagTrain = (): boolean => {
  const isTrain = config.environment === Environment.PRODUCTION && config.getAccountSlug() === 'train'
  const isStudio2 = config.environment === Environment.STAGE && config.getAccountSlug() === 'studio2'
  const isDev = config.environment === Environment.DEVELOPMENT

  const isEnabled = isTrain || isStudio2 || isDev
  return isEnabled
}
